import { Route, Routes } from "react-router-dom";
import { PositiveYouHome } from "./Views/PositiveYouHome/PositiveYouHome";
import { JournalEntry } from "./Views/JournalEntry/JournalEntry";
import { NotFound } from "../NotFound";
import { CreateJournalEntry } from "./Views/CreateJournalEntry/CreateJournalEntry";
import { EditJournalEntry } from "./Views/EditJournalEntry/EditJournalEntry";

export const PositiveYou = () => {
  return (
    <Routes>
      <Route index element={<PositiveYouHome />} />
      <Route path="entry" element={<JournalEntry />} errorElement={<NotFound />} />
      <Route path="create" element={<CreateJournalEntry />} />
      <Route path="edit" element={<EditJournalEntry />} />
    </Routes>
  );
};
